const countries = [
    {name: 'Select', value: ''},
    {name: 'Lao', value: 'Lao'},
    {name: 'Myanmar', value: 'Myanmar'},
    {name: 'Thailand', value: 'Thailand'},
    {name: 'United States', value: 'United States'}
]

export { countries }